var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainRestaurants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5625 18.0323H31.4375M29.6958 18.0323C29.6958 10.4687 23.5644 4.33643 16 4.33643C8.43562 4.33643 2.30417 10.4687 2.30417 18.0323",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2957 7.66262C8.88067 8.58574 7.71116 9.8389 6.88785 11.3142C6.06454 12.7896 5.61209 14.4429 5.56945 16.1319M15.9997 4.33604V2.54688M16.7438 23.3519C20.8589 23.302 21.3862 23.1302 28.9949 21.1985C29.4738 21.0774 29.8293 21.3228 29.9338 21.6015C30.0407 21.8865 29.9971 22.3916 29.3472 22.5602C28.0647 22.8927 20.0688 26.5819 18.248 26.5819C16.4272 26.5819 11.123 26.186 9.128 26.186C7.133 26.186 4.80549 27.4527 4.80549 27.4527C3.20633 25.9644 2.19299 23.4944 1.92383 20.8185H21.6838C22.4992 20.8185 22.7605 21.9585 22.0638 22.2752C21.0307 22.7447 19.2772 23.3519 16.7438 23.3519Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "currentColor",
    transform: "translate(0.75 0.0805664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainRestaurants);
export default __webpack_public_path__ + "static/media/mainRestaurants.7493e68099fa4cac4c6964778b9229cb.svg";
export { ForwardRef as ReactComponent };